var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCellIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.5h-.085C2.09 12.935.695 4.645.5 2.115A1.5 1.5 0 0 1 1.88.5h2.755a1 1 0 0 1 .93.63L6.325 3a1 1 0 0 1-.22 1.08L5.04 5.155a4.685 4.685 0 0 0 3.79 3.8L9.915 7.88A1 1 0 0 1 11 7.675l1.885.755a1 1 0 0 1 .615.93V12a1.5 1.5 0 0 1-1.5 1.5zM2 1.5a.5.5 0 0 0-.5.5v.04C1.73 5 3.205 12 11.97 12.5a.5.5 0 0 0 .53-.47V9.36l-1.885-.755L9.18 10.03 8.94 10C4.59 9.455 4 5.105 4 5.06l-.03-.24 1.42-1.435L4.64 1.5H2z",
    fill: "#696871"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellIcon);
export default __webpack_public_path__ + "static/media/cellIcon.02422b42f1b5608e513f86c1c263a204.svg";
export { ForwardRef as ReactComponent };